import { Glue42Core } from "@glue42/core";
import { Environment } from "./../types";
import { default as GD } from "./gd/gd";
import { Glue42 } from "../../../glue";

export default (agm: Glue42Core.AGM.API, logger: Glue42Core.Logger.API, appManagerGetter: () => Glue42.AppManager.API, displayAPIGetter: () => Glue42.Displays.API, channelsAPIGetter: () => Glue42.Channels, gdMajorVersion: number): Promise<Environment> => {
    const _logger = logger;
    if (gdMajorVersion === 2) {
        // We are running in HC
        _logger.trace("running in HC");
        throw new Error("GD2 not supported");
    } else if (gdMajorVersion >= 3) {
        // We are running in GD 3
        _logger.trace("running in GD 3");
        return new GD(agm, _logger, appManagerGetter, displayAPIGetter, channelsAPIGetter, window.glue42gd.windowId).init();
    } else {
        // We are running in Browser or Node, we should check which stream is available
        // But we need to pass the container as dependency
        return new GD(agm, _logger, appManagerGetter, displayAPIGetter, channelsAPIGetter).init();
    }
};
